import {RESUME_GAME, SHOW_GAME_INTRO, START_GAME} from "./action";
import {AnyAction} from "redux";


/**
 * start the game by showing the intro slideshow
 */
export function showGameIntro() : AnyAction
{
    return {type: SHOW_GAME_INTRO};
}


/**
 * start the game
 */
export function startGame() : AnyAction
{
    return {type: START_GAME};
}


/**
 * reseme the main game after playing a mini game
 */
export function resumeGame() : AnyAction
{
    return {type: RESUME_GAME};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/game.ts